import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import APIServicenew from "../utils/APIGeneralService";
import { Container, Row, Col, InputGroup, Form, Button } from "react-bootstrap";
import { FaRegEnvelope, FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { getCookies, setCookies } from "../utils/Helper";
import { UserContext } from "../context/UserContextProvider";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Login = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [load, setLoad] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const { setAccessToken } = useContext(UserContext);
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const headers = { "auth-token": authToken };

  useEffect(() => {
    const savedEmail = getCookies("savedEmail");
    if (savedEmail) {
      setUsername(savedEmail);
      setRememberMe(true);
    }
  }, []);

  const validate = () => {
    const errors = {};
    if (!username) {
      errors.email = "Email/Username is required.";
    }
    if (!password) {
      errors.password = "Password is required.";
    } else if (password.length < 6) {
      errors.password = "Password must be at least 6 characters.";
    } else if (password.length > 20) {
      errors.password = "Password must not exceed 20 characters.";
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoad(true);
    if (validate()) {
      const res = await APIServices.post(
        "admin/login",
        {
          username,
          password,
        },
        headers
      );

      if (res?.data?.status == true) {
        setLoad(false);
        let accessToken = res?.data?.data?.access_token;
        setCookies("accessToken", accessToken);
        setCookies("user_type", res.data?.data?.data?.user_type);
        setCookies("role_id", res.data?.data?.data?.role_id);
        setCookies("name", res.data?.data?.data?.name);
        setAccessToken(accessToken);
        if (rememberMe) {
          localStorage.setItem("token", res?.data?.data?.access_token);
        }
        if (rememberMe) {
          setCookies("savedEmail", username, 30);
        } else {
          setCookies("savedEmail", "", -1);
        }
        showToast(res?.data?.message || "Success", "success");
        setTimeout(() => {
          navigate("/admin/dashboard");
        }, 2000);
      } else {
        showToast(res?.data?.message || "Something went wrong.", "error");
        setLoad(false);
      }
    }
    setLoad(false);
  };

  const handleEmailChange = (e) => {
    setUsername(e.target.value);
    if (errors.email) {
      setErrors((prevErrors) => ({ ...prevErrors, email: "" }));
    }
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    if (errors.password) {
      setErrors((prevErrors) => ({ ...prevErrors, password: "" }));
    }
  };

  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
      hideProgressBar: false,
      closeOnClick: true,
    });
  };

  return (
    <>
      <div className="login_sec">
        <Container fluid className="p-0">
          <Row className="gx-0 align-items-center">
            <Col md={6} lg={6}>
              <div className="login_graph p-4">
                <img src="/images/vector.svg" className="img-fluid" alt="Login Frame" />
              </div>
            </Col>

            <Col md={6} lg={6}>
              <div className="login_form p-4">
                <div className="text-center mb-4">
                  <img
                    src='/images/msl_logo.png'
                    alt="Logo"
                    className="img-fluid"
                  />
                </div>
                <h2 className="font_blue_20 font-600 mb-4 line-height26 text-center">
                  Sign In Your Account
                </h2>
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Label className="font_blue_14 font-500 mb-3">Email ID /Username</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        placeholder="Enter Email / Username"
                        value={username}
                        onChange={handleEmailChange}
                      />
                      <InputGroup.Text>
                        <FaRegEnvelope />
                      </InputGroup.Text>
                    </InputGroup>
                    {errors.email && <div className="text-danger mt-2">{errors.email}</div>}
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formPassword">
                    <Form.Label className="font_blue_14 font-500 mb-2">Password</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        placeholder="Enter Password"
                        value={password}
                        onChange={handlePasswordChange}
                      />
                      <InputGroup.Text
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                      </InputGroup.Text>
                    </InputGroup>
                    {errors.password && <div className="text-danger mt-2">{errors.password}</div>}
                  </Form.Group>

                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <Form.Check
                      type="checkbox"
                      label="Remember Me"
                      checked={rememberMe}
                      onChange={(e) => setRememberMe(e.target.checked)}
                    />
                    <a  onClick={() => navigate("/forget-password")}  className="pointer text-danger font_blue_14 font-500">Forgot Password?</a>
                  </div>

                  <Button
                    className="btn red_button w-100"
                    type="submit"
                    disabled={load}
                  >
                    {load ? "Processing..." : "Sign In"}
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <ToastContainer />
    </>
  );
};

export default Login;
